export const tableColumns =  {
    "deviceType": {
      "title": "Device Category",
      "key": "deviceType",
    },
    "ads": {
      "title": "Ads",
      "key": "ads",
    },
    "adVisits": {
      "title": "Ad Visits",
      "key": "adVisits",
    },
    "visitOfAds": {
      "title": "Ad Visits/Ads",
      "key": "visitOfAds",
    }
  };


export const csvColumns = {
    "deviceType":{
       "title":"Device Category",
       "key":"deviceType"
    },
    "adVisits":{
       "title":"Ad Visits",
       "key":"adVisits"
    },
    "adVisitsRate":{
       "title":"Ad Visits Percentage",
       "key":"adVisitsRate"
    },
    "ads":{
       "title":"Ads",
       "key":"ads"
    },
    "visitOfAds":{
       "title":"Ad Visits/Ads",
       "key":"visitOfAds"
    }
 };

export const INIT_NEW_AD_USERS_PER_AD_SORT = {
    sortKey: 'newAdUsersOfAds',
    sortType: 'desc'
};

export const INIT_NEW_AD_USERS_SORT = {
    sortKey: 'newAdUsers',
    sortType: 'desc'
};

export const INIT_AD_VISITS_SORT = {
  sortKey: 'adVisits',
  sortType: 'desc'
};
